import { createServiceStateApi } from './_serviceState';
export default createServiceStateApi('datasources');
